import { render, staticRenderFns } from "./common-table.vue?vue&type=template&id=313da056&scoped=true&"
import script from "./common-table.vue?vue&type=script&lang=ts&"
export * from "./common-table.vue?vue&type=script&lang=ts&"
import style0 from "./common-table.vue?vue&type=style&index=0&id=313da056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313da056",
  null
  
)

export default component.exports